import { connect } from 'react-redux';
import homeSelector from 'selectors/home';
import Actions from 'actions/home';
import Home from 'components/Home';
import { StateProps, DispatchProps } from 'components/Home';

const HomeContainer = connect<StateProps, DispatchProps>(homeSelector, Actions)(Home);

export default HomeContainer;



// WEBPACK FOOTER //
// ./src/containers/HomeContainer.ts